import api from "src/apis/api";

export const loginUser = ({ email, password, rememberMe }) =>
  api.post("/users/sign_in", {
    user: {
      email,
      password,
      remember_me: rememberMe ? "1" : "0",
    },
  });

export const signupUser = ({ role, email, phoneCountry, phone, reraCertificate, password, passwordConfirmation }) => {
  const formData = new FormData();
  formData.append("user[role]", role);
  formData.append("user[email]", email);
  formData.append("user[phone]", `${phoneCountry}${phone}`);
  formData.append("user[password]", password);
  formData.append("user[password_confirmation]", passwordConfirmation);
  if (reraCertificate) {
    formData.append("rera_details[rera_certificate]", reraCertificate);
  }

  return api.post("/users", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const logoutUser = () => api.delete("/users/sign_out");

export const updatePassword = ({ currentPassword, password, passwordConfirmation }) =>
  api.patch("/api/v1/users/password", {
    current_password: currentPassword,
    password,
    password_confirmation: passwordConfirmation,
  });

